import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/lane-capacities");

export const Route = createFileRoute("/lane-capacities")({
  head: () => ({
    meta: [
      { title: "Lane rates — LevelLoad" },
      { name: "description", content: "Lane rates — LevelLoad transport planning." },
      { property: "og:title", content: "Lane rates — LevelLoad" },
      { property: "og:description", content: "Lane rates — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
